import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import View from './View';

class adminOrderlistView extends View {
  _parentElement = document.querySelector('.main');

  _errorMessage = 'Admin Order List View Error Message';
  _message = 'Admin Order List View Success Message';

  addHandlerOrderSearch(handler) {
    const searchForm = document.querySelector('.orderlist__search--form-admin');
    if (!searchForm) return;

    searchForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const dataArr = [...new FormData(searchForm)];
      const data = Object.fromEntries(dataArr);

      handler(data);
    });
  }

  addHandlerOrder(handler) {
    this._parentElement.addEventListener('click', e => {
      // e.preventDefault();
      e.stopImmediatePropagation();
      const order = e.target.closest('.orderlist__item--detail');
      if (!order) return;

      handler(order.dataset.id, 'id');
    });
  }

  _generateMarkup() {
    this._parentElement = document.querySelector('.profile__detail');
    const orders = this._data;

    let orderMarkup;
    if (Array.isArray(orders)) {
      this._parentElement = document.querySelector('.orderlist')
        ? document.querySelector('.orderlist')
        : document.querySelector('.profile-detail');
      orderMarkup = orders
        .map(
          order => `
                    <li class="orderlist__item" >
                <div class="orderList__item--container">
                  <a href="/product?${order.slug}" target="_blank" class="link">
                    <div class="orderlist__item--img">
                      <img
                        src="${ASSETS}images/product/${order.imageCover}"
                        alt="${order.tag}"
                      />
                    </div>
                  </a>
                  <div  class="orderlist__item--detail" data-id=${order._id}>
                    <div class="">
                      <h3 class="orderlist__item--title">
                        ${order.brand}
                      </h3>
                      <h4 class="orderlist__item--tag">${order.tag}</h4>
                      <div class="product__size--button">
                        <button
                          class="product__size--btn product__size--btn-selected orderlist__size"
                          data-size="${order.size}"
                        >
                          ${order.size}
                        </button>
                      </div>
                      <p class="paragraph paragraph__small">#${order._id}</p>
                    </div>

                    <div class="orderlist__item--price">
                      <span class="orderlist__item--discounted-price"
                        >₹ ${order.price}</span
                      >
                      ${
                        order.mrp && order.mrp - order.price > 0
                          ? `<span class="orderlist__item--mrp">₹ ${order.mrp}</span> 
                      <span class="orderlist__item--discount-percent"
                        >(${Math.ceil(((order.mrp - order.price) * 100) / order.mrp)}% OFF)</span
                      >`
                          : ''
                      }
                      
                    </div>
                  </div>
                </div>
                ${
                  order.deliveryDate
                    ? `<p class="orderlist__status orderlist__status--delivered">
                        Delivered on:                     
                        ${new Intl.DateTimeFormat(navigator.language, {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric',
                        }).format(new Date(order.deliveryDate))} 
                        ${order.paymentMethod === 'cod' ? `| <strong>COD</strong>` : ``}
                      </p>`
                    : `${
                        order.paymentMethod && order.expectedDelivery
                          ? `<p class="orderlist__status">
                          Expected delivery on: 
                          ${new Intl.DateTimeFormat(navigator.language, { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(order.expectedDelivery))} 
                          ${order.paymentMethod === 'cod' ? `| <strong>COD</strong>` : ``}
                      </p>`
                          : `<p class="orderlist__status orderlist__status--due">
                          Payment status: ${order.deliveryStatus}
                        </p>`
                      }`
                }

      `,
        )
        .reverse()
        .join('');
    }

    if (!this._parentElement)
      this._parentElement = document.querySelector('.profile__detail');

    return `
    ${
      this._parentElement.classList.contains('profile__detail')
        ? `        
      <form action="#" class="orderlist__search--form orderlist__search--form-admin">
          <div class="orderlist__search--terms">
            <div class="orderlist__search--props">
              <label for="">Search Using:</label>
              <input type="tel" name="mobile" id="" placeholder="Mobile" />
              <input type="email" name="email" id="" placeholder="Email" />
              <input type="string" name="_id" id="" placeholder="Order id" />
              <input
                type="string"
                name="receiptId"
                id=""
                placeholder="Receipt No"
              />
              <div class="label-input">
                <label for="delivery-status">Delivery Status:</label>
                <select id="delivery-status" name="deliveryStatus">
                  <option value=""></option>
                  <option value="!delivered" selected>Not Delivered</option>
                  <option value="delivered">Delivered</option>
                  <option value="payment due">Payment due</option>
                  <option value="order accepted">Order accepted</option>
                  <option value="in transit">In transit</option>
                  <option value="reached nearest hub">Reached nearest hub</option>
                </select>
              </div>
            </div>
            <div class="orderlist__search--status">
              <div class="label-input">
                <label for="status">Payment Status:</label>
                <select id="status" name="status">
                  <option value=""></option>
                  <option value="created">Created</option>
                  <option value="paid">Paid</option>
                </select>
              </div>
              <div class="label-input">
                <label for="method">Payment Method:</label>
                <select id="method" name="paymentMethod">
                  <option value=""></option>
                  <option value="cod">COD</option>
                  <option value="online">Online</option>
                </select>
              </div>
              <div class="label-input">
                <label for="from">From:</label>
                <input type="date" id="from" name="from"/>
              </div>
              <div class="label-input">
                <label for="to">To:</label>
                <input type="date" id="to" name="to"/>
              </div>
            </div>
          </div>
          <div class="orderlist__search--btn-container">
            <button type="search" class="btn orderlist__search--btn">
              Search
            </button>
          </div>
        </form>`
        : ``
    }

    
        <div class="row orderlist">
        ${
          Array.isArray(orders)
            ? `
        <div class="orderlist__head">
          <h2 class="orderlist__heading orderlist__admin">
          Total Orders: ${orders.length}  |  
          COD: ${orders.filter(el => el.paymentMethod && el.paymentMethod === 'cod').length}  |  
          Online: ${orders.filter(el => el.paymentMethod && el.paymentMethod === 'online').length}  |  
          Due: ${orders.filter(el => !el.paymentMethod).length}</h2>
        </div>

        <div class="orderlist__container">
          <div class="orderlist__items--container">
            <ul class="orderlist__items">
            ${orderMarkup}
            </ul>
          </div>
        </div>          
          
          `
            : ``
        }


        
      </div>
    `;
  }
}

export default new adminOrderlistView();
